import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getSearchHistory = async () => {
  const { data: searchHistory, error: searchHistoryError } = await supabase
    .from('salons_search_history')
    .select(`*`)
    .eq('popular', true);

  if (searchHistoryError) {
    throw new Error(searchHistoryError.message);
  }

  return searchHistory;
};

export default function useGetPopularSeachSuggestions() {
  return useQuery({
    queryKey: ['useGetPopularSeachSuggestions', ],
    queryFn: () => getSearchHistory(),
  });
}
